import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCFsaWJx36SVM6FpAc5OAmX2wNYm6kfPj4",
    authDomain: "dragana-jevtovic.firebaseapp.com",
    databaseURL: "https://dragana-jevtovic.firebaseio.com",
    projectId: "dragana-jevtovic",
    storageBucket: "dragana-jevtovic.appspot.com",
    messagingSenderId: "1056571175717",
    appId: "1:1056571175717:web:401304b644777efc2360cc",
    measurementId: "G-L0P5EQ9NE5"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

isSupported().then((supported) => {
    if (supported) {
        getAnalytics(app);
    }
});

export { app, auth, db };
